/**
 * Web: expo-image forwards `alt` to the underlying <img> (SEO / Lighthouse).
 * Empty string = decorative (valid when meaning is in adjacent text/UI).
 */
export const EXPO_IMAGE_ALT_DECORATIVE = '';

export const getExpoImageAltTeamLogo = (teamLabel: string): string =>
  `${teamLabel} club badge`;

export const getExpoImageAltAvatar = (displayName?: string | null): string => {
  const n = displayName?.trim();
  return n ? `Avatar for ${n}` : 'User avatar';
};

export const getExpoImageAltGroupImage = (groupName?: string | null): string => {
  const n = groupName?.trim();
  return n ? `${n} group` : 'Group image';
};

export const EXPO_IMAGE_ALT_PROFILE_PHOTO = 'Profile photo';

export const getExpoImageAltTutorialSlide = (slideTitle: string): string => {
  const t = slideTitle.trim();
  return t ? `Tutorial: ${t}` : 'Tutorial illustration';
};

export const getExpoImageAltCoinsReward = (amount: number): string => `${amount} coins`;
